export default "__VITE_ASSET__CPrl4Zw2__"